module.exports = __webpack_public_path__ + "img/CyberHeroesSeriesInternetThreats.97a6f7a5.jpg";